import React, { useContext } from "react"
import { Link } from "react-router-dom"
import { LogOut, ShieldCheck } from "lucide-react"

import { BookingContext } from "../../utils/providers/isolated-booking"
import Logo from "../../assets/images/golf-holidays-direct-logo.png"
import PortalNav from "./portal-nav"
import PortalMobileNav from "./portal-mobile-nav"

import styles from "./portal-shell.module.scss"

/**
 * App chrome for the redesigned client portal: a sticky header (logo + booking
 * reference + exit), the section navigation, the content column, and a footer
 * carrying the financial-protection reassurance.
 *
 * Rendered around every route so navigation feels like one consistent app.
 */
export default function PortalShell({ bookingID, children }) {
	const { reference } = useContext(BookingContext)

	// All section links hang off the booking's base path.
	const base = `/itinerary/${bookingID}`

	return (
		<div className={styles.shell}>
			<header className={styles.header}>
				<div className={styles.headerInner}>
					<Link
						to={base}
						className={styles.brand}>
						<img
							src={Logo}
							alt="Golf Holidays Direct"
						/>
					</Link>

					<div className={styles.headerMeta}>
						{reference ? <span className={styles.refChip}>Booking #{reference}</span> : null}

						<Link
							to="/mybooking"
							className={styles.exit}>
							<LogOut size={16} />
							<span>Exit</span>
						</Link>
					</div>
				</div>

				<PortalNav base={base} />
			</header>

			<main className={styles.main}>{children}</main>

			<footer className={styles.footer}>
				<div className={styles.footerInner}>
					<span className={styles.footerProtect}>
						<ShieldCheck size={16} />
						ATOL protected (11357) &middot; Money held in trust
					</span>
					<p>
						&copy; {new Date().getFullYear()} Golf Holidays Direct &middot;{" "}
						<a
							href="https://www.golfholidaysdirect.com/terms-conditions"
							target="_blank"
							rel="noreferrer">
							Terms &amp; Conditions
						</a>
					</p>
				</div>
			</footer>

			<PortalMobileNav base={base} />
		</div>
	)
}
